import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const TripDetailsForm = ({ formData, errors, onChange, userProfile }) => {
  const isPremiumUser = userProfile?.subscriptionStatus === 'premium';
  
  const crewSizeOptions = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' }
  ];

  const durationOptions = [
    { value: '1', label: '1 day' },
    { value: '2', label: '2 days' },
    { value: '3', label: '3 days' },
    { value: '4', label: '4 days' },
    { value: '5', label: '5 days' },
    { value: '6', label: '6 days' },
    { value: '7', label: '7 days (Trial Limit)' },
    { value: '8', label: '8 days', disabled: !isPremiumUser },
    { value: '9', label: '9 days', disabled: !isPremiumUser },
    { value: '10', label: '10 days', disabled: !isPremiumUser },
    { value: '14', label: '14 days', disabled: !isPremiumUser },
    { value: '21', label: '21 days', disabled: !isPremiumUser },
    { value: '30', label: '30 days', disabled: !isPremiumUser },
    { value: '35', label: '35 days', disabled: !isPremiumUser },
    { value: '40', label: '40 days', disabled: !isPremiumUser },
    { value: '45', label: '45 days', disabled: !isPremiumUser },
    { value: '50', label: '50 days', disabled: !isPremiumUser },
    { value: '55', label: '55 days', disabled: !isPremiumUser },
    { value: '60', label: '60 days', disabled: !isPremiumUser }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl md:text-3xl font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>
          Trip Details
        </h2>
        <p className="text-sm md:text-base" style={{ color: 'var(--color-text-secondary)' }}>
          Configure your coastal cruising parameters for accurate meal planning
        </p>
      </div>
      <Input
        label="Trip Name"
        type="text"
        name="tripName"
        placeholder="e.g., Caribbean Coastal Cruise"
        value={formData?.tripName}
        onChange={onChange}
        error={errors?.tripName}
        required
        description="Give your sailing adventure a memorable name"
      />
      <Select
        label="Crew Size"
        name="crewSize"
        options={crewSizeOptions}
        value={formData?.crewSize}
        onChange={(value) => onChange({ target: { name: 'crewSize', value } })}
        error={errors?.crewSize}
        required
        description="Number of people on board"
      />
      <Select
        label="Trip Duration"
        name="duration"
        options={durationOptions}
        value={formData?.duration}
        onChange={(value) => onChange({ target: { name: 'duration', value } })}
        error={errors?.duration}
        required
        description={!isPremiumUser ? "Trial mode limited to 7 days. Upgrade for longer trips." : "Select your trip length"}
      />
      <div className="space-y-2">
        <label className="block text-sm font-medium" style={{ color: 'var(--color-text-primary)' }}>
          Dietary Restrictions / Food Allergies
        </label>
        <textarea
          name="dietaryRestrictions"
          placeholder="e.g., Gluten-free, Dairy allergy, Vegetarian, Nut allergy..."
          value={formData?.dietaryRestrictions || ''}
          onChange={onChange}
          rows={3}
          className="w-full px-3 py-2 rounded-lg border text-sm"
          style={{
            backgroundColor: 'var(--color-input)',
            borderColor: 'var(--color-border)',
            color: 'var(--color-text-primary)'
          }}
        />
        <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
          List any dietary restrictions or food allergies for crew members
        </p>
      </div>
      {!isPremiumUser && (
        <div className="flex items-start gap-3 p-4 rounded-lg" style={{ backgroundColor: 'var(--color-muted)' }}>
          <div className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center mt-0.5" style={{ backgroundColor: 'var(--color-warning)' }}>
            <span className="text-xs font-semibold" style={{ color: 'var(--color-warning-foreground)' }}>!</span>
          </div>
          <div className="flex-1">
            <p className="text-sm font-medium mb-1" style={{ color: 'var(--color-text-primary)' }}>
              Trial Mode Active
            </p>
            <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
              Your account is limited to 7-day trips. Upgrade to Premium to plan longer coastal cruises and unlock advanced features.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TripDetailsForm;